import { render } from "./ModalDigitalPaymentSummary.vue?vue&type=template&id=1dbba6b6&scoped=true"
import script from "./ModalDigitalPaymentSummary.vue?vue&type=script&lang=js"
export * from "./ModalDigitalPaymentSummary.vue?vue&type=script&lang=js"

import "./ModalDigitalPaymentSummary.vue?vue&type=style&index=0&id=1dbba6b6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dbba6b6"]])

export default __exports__